module.exports = __webpack_public_path__ + "assets/c389901ae77c2e6ec8f4b2f37df59633.svg";